export const PATIENT_NAME_MAX_LENGTH = 30

export function truncatePatientName(name, maxLength = PATIENT_NAME_MAX_LENGTH) {
  if (!name || name.length <= maxLength) {
    return name || ''
  }

  return `${name.slice(0, maxLength)}...`
}

export function resolvePatientDisplayNames({ patientName, socialName }) {
  const normalizedSocialName = socialName?.trim() || ''
  const hasSocialName = Boolean(normalizedSocialName)
  const truncatedCivilName = truncatePatientName(patientName || '')
  const primaryName = hasSocialName
    ? truncatePatientName(normalizedSocialName)
    : truncatedCivilName

  return { hasSocialName, primaryName, truncatedCivilName, normalizedSocialName }
}
